export default "__VITE_ASSET__6efec909__"